import { ChevronDown, ChevronUp } from 'lucide-react';

/**
 * ExpandChevron — shared glyph-swap expand/collapse indicator (DASH-F3 / #781).
 *
 * Swaps ChevronUp/ChevronDown from a single `expanded` boolean prop.
 * Glyph swap only — zero motion, zero CSS animation.
 *
 * The glyph is decorative: aria-hidden="true". The component does NOT own the
 * expanded-state ARIA attribute — the toggle button owns it (button-owns-state
 * convention; verified live: WeatherAlertsSection:20, ForecastDayRow:178,
 * PropertyInsightsPanel:50, TaskCategoryAccordion, PrepHeader season-switcher).
 *
 * No hardcoded color — callers pass color tokens via className.
 *
 * Mirrors the no-motion precedent established by ConditionSparkline.
 */

interface ExpandChevronProps {
  expanded: boolean;
  /** Icon size in pixels. Forwarded to the Lucide glyph. Default: 14. */
  size?: number;
  /** CSS class forwarded to the glyph element for color tokens. */
  className?: string;
}

export function ExpandChevron({ expanded, size = 14, className }: ExpandChevronProps) {
  const Icon = expanded ? ChevronUp : ChevronDown;

  return (
    <span data-testid="expand-chevron" data-expanded={expanded ? 'true' : 'false'}>
      <Icon aria-hidden="true" size={size} className={className} />
    </span>
  );
}
